module.exports = __webpack_public_path__ + "img/adriana-torres.ad046b08.jpg";